
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/applied-jobs",
      function () {
        return require("private-next-pages/applied-jobs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/applied-jobs"])
      });
    }
  